(function($) {
    'use strict';

    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success);
        } else { 
            //x.innerHTML = "Geolocation is not supported by this browser.";
            console.log("Geolocation is not supported by this browser.");
        }
    }

    function success(pos) {
        var crd = pos.coords;
        //console.log('Your current position is:');
        //console.log(`Latitude : ${crd.latitude}`);
        //console.log(`Longitude: ${crd.longitude}`);
        //console.log(`More or less ${crd.accuracy} meters.`);
        var crds = crd.latitude+','+crd.longitude;
        prayerTimes(crds);
        prayerLocSet(crds);
        $(".prayerTimesSearch").toggle();
        $("html, body").animate({ scrollTop: 0 });
    }

    $(".prayerTimesGet").click(function(){
        getLocation();
    });

    $(".ptsToggle").click(function(e){
      let pts = document.getElementById('prayerTimesSearch')
      pts.classList.toggle('hidden')
    });
    
    // Prayer Times
    // https://medium.com/@emadalam/namespace-localstorage-e2d1d2e68b20
    const APP_NAME = 'PrayerTimes';
    //localStorage.setItem(`${APP_NAME}.userSetting`, 'AWESOME 1');
    //localStorage.getItem(`${APP_NAME}.userSetting`); // AWESOME 1
    //localStorage.removeItem(`${APP_NAME}.userSetting`);
    
    function prayerLocSet(location="pemagarsari") {
        // Check browser support and store in localStorage
        if (typeof(Storage) !== "undefined") {
            localStorage.setItem(`${APP_NAME}.location`, location);
        } else {
            console.log("Sorry, your browser does not support Web Storage so we can't remember your location...");
        }
    }

    function prayerLocGet() {
        // Check browser support and get location from localStorage if exist or return "pemagarsari" as default
        if (typeof(Storage) !== "undefined") {
            var location = localStorage.getItem(`${APP_NAME}.location`);
            if (location !== null) {
                return location;
            } else {
                return "pemagarsari";
            }
        } else {
            console.log("Sorry, your browser does not support Web Storage so we can't remember your location...");
        }
    }
    
    
    function prayerMethod(country) {
        // Set default methods by country
        var method = 'MWL';
        switch (country) {
            case 'Indonesia':
                method = 'Kemenag';
                break;
            case 'Canada':
                method = 'ISNA';
                break;
            case 'Bahrain':
            case 'Iraq':
            case 'Jordan':
            case 'Kuwait':
            case 'Oman':
            case 'Qatar':
            case 'Saudi Arabia':
            case 'United Arab Emirates':
            case 'Yemen':
                method = 'Makkah';
        };
        return method;
    }
    
    function prayerMethodSet(method=prayerMethod()) {
        // Check browser support and store in localStorage
        if (typeof(Storage) !== "undefined") {
            localStorage.setItem(`${APP_NAME}.method`, method);
        } else {
            console.log("Sorry, your browser does not support Web Storage so we can't remember your location...");
        }
    }

    function prayerMethodGet(country) {
        // Check browser support and get method from localStorage if exist or return default
        if (typeof(Storage) !== "undefined") {
            var localStorageMethod = localStorage.getItem(`${APP_NAME}.method`);
            if (localStorageMethod !== null) {
                return localStorageMethod;
            } else {
                return prayerMethod(country);
            }
        } else {
            console.log("Sorry, your browser does not support Web Storage so we can't remember your location...");
        }
    }
    
    $( document ).ready(function() {
        prayerTimes(prayerLocGet());
    });
    
    function prayerTimes() {
    if (!navigator.geolocation) {
        alert("Geolocation is not supported by your browser");
        return;
    }

    $('.card').addClass('is-loading');

    navigator.geolocation.getCurrentPosition(function (position) {
        let lat = position.coords.latitude;
        let lng = position.coords.longitude;

        // Get timezone offset in hours
        let timezone = -new Date().getTimezoneOffset() / 60;

        // Default address placeholder (since we’re not reverse-geocoding)
        let address = `Your Location`;
        let country = "Unknown";

        // Use your own logic for determining default method
        let method = prayerMethodGet(country);

        function updatePrayerTimes(method) {
            let PT = new PrayTimes(method);
            let date = new Date();
            let times = PT.getTimes(date, [lat, lng], timezone, 'auto', '12h');
            let currentMethod = PT.getMethod();

            let methods = {
                MWL: { name: 'Muslim World League', params: { fajr: 18, isha: 17 } },
                ISNA: { name: 'Islamic Society of North America (ISNA)', params: { fajr: 15, isha: 15 } },
                Egypt: { name: 'Egyptian General Authority of Survey', params: { fajr: 19.5, isha: 17.5 } },
                Makkah: { name: 'Umm Al-Qura University, Makkah', params: { fajr: 18.5, isha: '90 min' } },
                Karachi: { name: 'University of Islamic Sciences, Karachi', params: { fajr: 18, isha: 18 } },
                Tehran: { name: 'Institute of Geophysics, University of Tehran', params: { fajr: 17.7, isha: 14, maghrib: 4.5, midnight: 'Jafari' } },
                Jafari: { name: 'Shia Ithna-Ashari, Leva Institute, Qum', params: { fajr: 16, isha: 14, maghrib: 4, midnight: 'Jafari' } },
                Kemenag: { name: 'Kementerian Agama RI', params: { fajr: 20, isha: 18 } }
            };

            $('.card').removeClass('is-loading');

            $('.prayerTimesTitle').html(address);
            $('.prayerTimesDate').html(date.toDateString());
            $('.fajr .prayerTime').html(times.fajr);
            $('.sunrise .prayerTime').html(times.sunrise);
            $('.dhuhr .prayerTime').html(times.dhuhr);
            $('.asr .prayerTime').html(times.asr);
            $('.maghrib .prayerTime').html(times.maghrib);
            $('.isha .prayerTime').html(times.isha);

            $('.method').html(`<label for="methods">Based on:</label><select name="methods" id="methods" class="custom-select"></select>`);
            $.each(methods, function (index, value) {
                if (index !== prayerMethod(country)) {
                    $('#methods').append($('<option/>', { value: index, text: value.name }));
                } else {
                    $('#methods').append($('<option/>', { value: index, text: value.name + " (Default)" }));
                }
            });

            $('#methods').val(currentMethod);
            $('.timezone').html(`GMT <b>${timezone}</b> &middot; Latitude/Longitude <b>${lat}, ${lng}</b> &middot; Daylight Saving <b>Auto</b>`);

            $('#methods').change(function () {
                updatePrayerTimes(this.value);
                prayerMethodSet(this.value);
            });
        }

        updatePrayerTimes(method);

    }, function (error) {
        alert("Unable to retrieve your location: " + error.message);
        $('.card').removeClass('is-loading');
    });
}

    
    var prayerLocation = $("#locationSearchForm");
    var input_name = "search";
    var input = $("#locationSearchForm :input[name='"+input_name+"']"); 
    prayerLocation.submit(function(e){
        var location = input[0].value;
        prayerLocSet(location);
        prayerTimes(location);
        localStorage.removeItem(`${APP_NAME}.method`);
        $("html, body").animate({ scrollTop: 0 });
        e.preventDefault();
    });
        
} ) ( jQuery );
